import { createContext, type Dispatch, type Reducer, type ReducerState } from "react";

import type { AuthHeaderReducer } from "./AuthHeaderProvider";

type ReducerAction<R extends Reducer<any, any>> = R extends Reducer<any, infer A> ? A : never;

interface AuthHeaderContextType {
    state: ReducerState<AuthHeaderReducer>;
    dispatch: Dispatch<ReducerAction<AuthHeaderReducer>>;
}

export const AuthHeaderContext = createContext<AuthHeaderContextType | undefined>(undefined);
